import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function bars(element: Element): void {
  const bars = [...Array.from(element.querySelectorAll('.js-bar'))] as HTMLElement[]

  bars.forEach((bar, index) => {
    const barTl = gsap.timeline({
      scrollTrigger: {
        trigger: bar,
        start: 'center bottom',
        // end: 'center center',
        // scrub: 1,
        // markers: true,
        invalidateOnRefresh: true
      }
    })

    // find even
    let isEven = index % 2 === 0
    let movement

    isEven ? (movement = 25) : (movement = -25)

    barTl.fromTo(
      bar,
      { xPercent: movement, autoAlpha: 0 },
      {
        xPercent: 0,
        duration: 1.7,
        ease: 'expo.out',
        autoAlpha: 1
      }
    )
  })
}
